import * as Sentry from '@sentry/react';
import { getSessionInfo } from '../../utils/getSessionInfo';

export const addInfoBreadcrumb = (message: string, data?: Record<string, unknown>) => {
	try {
		Sentry.addBreadcrumb({ message, data, level: 'info' });
	} catch (e) {
		// never throw from instrumentation
		// eslint-disable-next-line no-console
		console.info(message, data, e);
	}
};

export const captureException = (err: unknown, ctx?: { fn?: string; args?: any }) => {
	try {
		const { userInfo, cartId } = getSessionInfo() || {};
		Sentry.withScope((scope) => {
			if (ctx?.fn) scope.setTag('fn', ctx.fn);
			if (ctx?.args) scope.setExtra('args', ctx.args);
			if (userInfo?.profile?.email) scope.setUser({ email: userInfo.profile.email, id: userInfo._id });
			if (cartId) scope.setTag('cartId', cartId);
			scope.setExtra('timestamp', Date.now());

			if (err instanceof Error) {
				Sentry.captureException(err);
			} else {
				try {
					Sentry.captureException(new Error(typeof err === 'string' ? err : JSON.stringify(err)));
				} catch (e) {
					// fallback
					Sentry.captureMessage(String(err));
				}
			}
		});
	} catch (e) {
		// avoid throwing from within error handling
		// eslint-disable-next-line no-console
		console.error('Sentry capture failed', e);
	}
};
